import { render, staticRenderFns } from "./SaitenBoxScoreStamp.vue?vue&type=template&id=f8acc400&scoped=true&"
import script from "./SaitenBoxScoreStamp.vue?vue&type=script&lang=ts&"
export * from "./SaitenBoxScoreStamp.vue?vue&type=script&lang=ts&"
import style0 from "./SaitenBoxScoreStamp.vue?vue&type=style&index=0&id=f8acc400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8acc400",
  null
  
)

export default component.exports